import { SAVED_COLLECTIONS_ROUTE } from '@/router/routeNames'

const SavedCollections = () => import(
  /* webpackChunkName: "saved-tables" */ '@/views/SavedCollections.vue'
)

const routes = [
  {
    path: SAVED_COLLECTIONS_ROUTE.path,
    name: SAVED_COLLECTIONS_ROUTE.name,
    component: SavedCollections,
    meta: {
      appFeatureSubRoute: SAVED_COLLECTIONS_ROUTE,
      title: SAVED_COLLECTIONS_ROUTE.title
    }
  }
]

export default routes
